import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import Container from 'react-bootstrap/Container';
import { useParams } from 'react-router';

import { Interaction } from '../Interaction.jsx'
import { Channel } from '../Channel.jsx'
import { MAP_TEMPLATES_SHOW_SEGMENTS } from '../common.js';
import MessageErreurToast from '../Components/UI/MessageErreurToast.jsx';
import { ManageConsent } from '../Components/Services/ManageConsent.jsx';
import { ManageDonneesPersonnelles } from '../Components/Services/ManageDonneesPersonnelles.jsx';
import { ManageAudioRecorder } from '../Components/Services/ManageAudioRecorder.jsx';
import { ManageVideoRecorder } from '../Components/Services/ManageVideoRecorder.jsx';
import { ManageNavigation } from '../Components/Services/ManageNavigation.jsx';
import { ManageParticipation } from '../Components/Services/ManageParticipation.jsx';
import { ManageResultats } from '../Components/Services/ManageResultats.jsx';
import { ManageUploadFile } from '../Components/Services/ManageUploadFile.jsx';
import { uuidv4 } from '../common.js';

function HomePage() {
    // Deal with deviceId 
    const previousDeviceId = localStorage.getItem('device_id');
    const deviceId = useRef(previousDeviceId);
    if (deviceId.current) {
        deviceId.current = previousDeviceId;
    } else {
        var newDeviceId = '';
        // Pour les tests en local ou sur VM local
        if(window.location.protocol === 'http:') {
            newDeviceId = uuidv4();
        }else {
            newDeviceId = crypto.randomUUID();
        }
        deviceId.current = newDeviceId;
        localStorage.setItem('device_id', newDeviceId);
    }
    // Get param from PAT
    const { interactionId, channelId } = useParams();

    // To get interaction data
    const { fetchInteraction } = Interaction(interactionId);
    const [interaction, setInteraction] = useState({});
    // To get channel data
    const { fetchChannel } = Channel(channelId);
    const [, setChannel] = useState({});
    // To get user data

    // Permet de construire un composant dynamiquement à partir de `nomComposant`
    const RendreComposant = ({ nomComposant, ...params }) => {
        // Vérifiez si le nom du composant existe dans le map
        const Composant = MAP_TEMPLATES_SHOW_SEGMENTS[nomComposant];

        // Si le composant existe, renvoyez-le avec les paramètres, sinon renvoyez un message d’erreur ou null
        return Composant ? <Composant {...params} /> : null //interaction={interaction} /> : null;
    };


    const sauvegarderParticipation = async () => {
        console.log("Sauvegarder participation")
        if (sendingParticipationState === 'sending') {
            console.log("Sauvegarde de la participation en cours")
            return;
        }
        console.log("Etat : " + sendingParticipationState);
        // Si audioBlob est renseigné sauvegarde via SendRecordParticipation
        //   * Cela permet de gérer le cas vote/texte avec témoignage
        //   * TODO adapter l'API pour avoir qu'une seule API de sauvegarde
        if (audioBlob != null) {
            await sendRecordParticipation();
            return;
        }
        if (interaction.template_widget_model.startsWith('GAM')) {
            // XXX Contournement pour l'enregistrement des jeux
            participation.textAnswer = "GAME";
            await envoyerParticipationTexteVersAPI();
            return;
        }
        if (interaction.template_widget_model.startsWith('TEX')) {
            await envoyerParticipationTexteVersAPI();
            return;
        }
        if (interaction.template_widget_model.startsWith('SUR')) {
            await envoyerParticipationVoteVersAPI();
            return;
        }
        if (interaction.template_widget_model.startsWith('VOC')) {
            // Dans le cas d'une participation vocale avec une alternative texte la participation est 
            //   * soit vocales (audioBlob renseigné)
            //   * soit texte (audioBlob null)
            if (audioBlob != null) {
                await sendRecordParticipation();
            }
            else {
                await envoyerParticipationTexteVersAPI();
            }
            return;

        }
        if (interaction.template_widget_model.startsWith('VID')) {
            // Cas de la participation vidéo avec alternative texte ou audi
            console.log(participation);
            if(participation.textAnswer !== null && participation.textAnswer !== "") {
                await envoyerParticipationTexteVersAPI();
            }
            else if (participation.image !== null){
                await sendRecordParticipationImage();
            }
            else if(participation.video !== null) {
                await sendRecordParticipationVideo();
            }
            else if(audioBlob !== null) {
                await sendRecordParticipation();
            }
            return;
        }
        if (interaction.template_widget_model.startsWith('IMA')) {
            await sendRecordParticipationImage();
            return;
        }

    }

    // Elements pour gérer la naviguation
    const [afficherAccueil, setAfficherAccueil] = useState(true);
    const [afficherEtapeCollecteParticipation, setAfficherEtapeCollecteParticipation] = useState(false);
    const [afficherEtapeCollecteParticipationVoix, setAfficherEtapeCollecteParticipationVoix] = useState(false);
    const [afficherEtapeCollecteParticipationTexte, setAfficherEtapeCollecteParticipationTexte] = useState(false);
    const [afficherEtapeCollecteParticipationImage, setAfficherEtapeCollecteParticipationImage] = useState(false);
    const [afficherEtapeRemerciement, setAfficherEtapeRemerciement] = useState(false);
    const [afficherEtapeGRPD, setAfficherEtapeGRPD] = useState(false);
    const [afficherEtapeTemoinage, setAfficherEtapeTemoinage] = useState(false);
    const [afficherMessageErreur, setAfficherMessageErreur] = useState(false);
    const [afficherEtapeCollectInformationsPersonnelles, setAfficherEtapeCollectInformationsPersonnelles] = useState(false);
    const [messageErreur, setMessageErreur] = useState("");




    const changerAfficherEtapeCollecteParticipation = () => {
        resetAffichageAllFalse();
        setAfficherEtapeCollecteParticipation(true);
    }
    const changerAfficherEtapeCollecteParticipationVoix = () => {
        resetAffichageAllFalse();
        setAfficherEtapeCollecteParticipationVoix(true);
    }
    const changerAfficherEtapeCollecteParticipationTexte = () => {
        resetAffichageAllFalse();
        setAfficherEtapeCollecteParticipationTexte(true);
    }
    const changerAfficherEtapeCollecteParticipationImage = () => {
        resetAffichageAllFalse();
        setAfficherEtapeCollecteParticipationImage(true);
    }


    const [sendingParticipationState, setSendingParticipationState] = useState('')

    /** Déclenche l'affichage de la page de rémerciement
     * 
     * s'il s'agit de la dernière page déclencher la sauvegarde des interactions
     * 
     */
    const changerEtapeRemerciement = async () => {
        if (estDernierePagePourSauver('collect_consent') && sendingParticipationState !== 'sended') {
            await sauvegarderParticipation();
        }
        resetAffichageAllFalse();
        setAfficherEtapeRemerciement(true)
    }

    const changerAfficherEtapeGRPD = () => {
        resetAffichageAllFalse();
        setAfficherEtapeGRPD(true);
    }

    const changerAfficherEtapeCollectInformationsPersonnelles = () => {
        resetAffichageAllFalse();
        setAfficherEtapeCollectInformationsPersonnelles(true);
    }

    const changerAfficherMessageErreur = async (show = false, message = "") => {
        setMessageErreur(message);
        setAfficherMessageErreur(show);
    }
    const changerAfficherEtapeTemoinage = () => {
        resetAffichageAllFalse();
        setAfficherEtapeTemoinage(true);
    }

    const resetAffichageAllFalse = () => {
        setAfficherAccueil(false);
        setAfficherEtapeCollecteParticipation(false);
        setAfficherEtapeTemoinage(false);
        setAfficherEtapeCollectInformationsPersonnelles(false);
        setAfficherEtapeGRPD(false);
        setAfficherEtapeRemerciement(false);
        setAfficherEtapeCollecteParticipationTexte(false);
        setAfficherEtapeCollecteParticipationVoix(false);
        setAfficherEtapeCollecteParticipationImage(false);
    }
    const retourAccueil = () => {
        reinitPage();
        resetAffichageAllFalse();
        setAfficherAccueil(true);
        intialisationDonneesPersonnelles();

        setAudioURL('');
        setAudioBlob(null);
        setConsentImage(false);
        setConsentGDPR(false);
        participation.id = null;
        participation.task_id = null;
        participation.image = null;
        setSendingParticipationState(null);
    }

    /** Déclenche l'affichage de la page de collecte des données de participation
     * texte. Sauvegarde les données s'il s'agit de la dernière page.
     */
    const changerEtapeCollecteParticipationTexte = async () => {
        console.log('changerEtapeCollecteParticipationTexte');
        if ((estDernierePagePourSauver('collect_data') || estDernierePagePourSauver('collect_testimonial')) && sendingParticipationState !== 'sended') {
            await sauvegarderParticipation();
        }
        changerPage();
    }

    /** Déclenche l'affichage de la page de collecte des données de participation 
     * de type vote. Sauvegarde les données s'il s'agit de la dernière page.
     */
    const changerEtapeCollecteParticipationVote = async () => {
        console.log('changerEtapeCollecteParticipationVote');
        if (estDernierePagePourSauver('collect_data')) {
            await sauvegarderParticipation();
        }
        changerPage();
    }

    const passerPageTemoignage = async () => {
        console.log("passer temoignage");
        changerPage();
    }


    const { changerPage, reinitPage, continueEnabled, setContinueEnabled, estDernierePagePourSauver } = ManageNavigation(interaction, changerEtapeRemerciement, changerAfficherEtapeGRPD, changerAfficherEtapeCollectInformationsPersonnelles, changerAfficherEtapeTemoinage)

    const { resultatsVote, fetchResults } = ManageResultats(interaction);

    const { participation, updateParticipation, envoyerParticipationTexteVersAPI, envoyerParticipationVoteVersAPI, asAlreadyVoted } = ManageParticipation(interaction, setSendingParticipationState, sendingParticipationState, changerPage, changerAfficherMessageErreur, fetchResults, deviceId);

    /** Déclenche l'affichage de la page de collecte des données de participation 
     * de type vocale. Sauvegarde les données s'il s'agit de la dernière page.
     */
    const changerEtapeCollecteParticipationVocale = async () => {
        console.log('changerEtapeCollecteParticipationVocale');
        if (estDernierePagePourSauver('collect_data')) {
            await sauvegarderParticipation();
        }
        else {
            changerPage();
        }
    }

    const { setField, saveDonneePersonnelle, intialisationDonneesPersonnelles, userInformation, donneesPersonnelleValid, handleRememberMeChange, rememberMe, canDonneesPersonnelleContinue, validateUserInformationsValid } = ManageDonneesPersonnelles(
        interaction,
        participation,
        changerPage,
    )



    const { audioBlob, setAudioBlob, sendRecordParticipation, audioURL, setAudioURL } = ManageAudioRecorder(participation, setSendingParticipationState, sendingParticipationState, setContinueEnabled, changerPage, updateParticipation, interaction);

    const { videoBlob, setVideoBlob, videoURL, setVideoURL } = ManageVideoRecorder(interaction, setSendingParticipationState, setContinueEnabled, changerPage);

    const { setConsent, setConsentGDPR, setConsentImage, consentImage, consentGDPR, passerEtapeRGPDEnabled } = ManageConsent(interaction, participation);

    const { sendRecordParticipationVideo, sendRecordParticipationImage } = ManageUploadFile(participation, setSendingParticipationState, sendingParticipationState, setContinueEnabled, changerPage, updateParticipation, interaction);

    const changerEtapeCollecteParticipationVideo = async () => {
        if (estDernierePagePourSauver('collect_data') && sendingParticipationState !== 'sended') {
            sendRecordParticipationVideo();
        }
        else {
            changerPage()
        }
    }
    const changerEtapeCollecteParticipationImage = async () => {
        if (estDernierePagePourSauver('collect_data') && sendingParticipationState !== 'sended') {
            sendRecordParticipationImage();
        }
        else {
            changerPage()
        }
    }
    useEffect(() => {
        async function init() {
            // fetch interaction data
            let interactionData = await fetchInteraction(interactionId);
            interactionData = await asAlreadyVoted(interactionData);
            setInteraction(interactionData);
            // fetch channel data
            const channelData = await fetchChannel(interactionId);
            setChannel(channelData);
            intialisationDonneesPersonnelles();
            ;

        }
        init();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <Helmet>
                <title>{interaction.title}</title>
                <meta name='description' content={interaction.text} />
                <meta name='widget_model' content={interaction.template_widget_model} />
                {interaction.templateShowSegment &&
                    <link
                        type="text/css"
                        rel="stylesheet"
                        href={"/widgets/v02/styles/" + interaction.templateShowSegment.styles} />
                }
                <style>
                    {interaction.styles}
                </style>
            </Helmet>
            <Container fluid="md" variant="custom" className="vc-outer-container d-flex align-items-center justify-content-center">
                <Container className={afficherAccueil ? "vc-first-middle-container d-flex align-items-center justify-content-center accueil" :
                "vc-first-middle-container d-flex justify-content-center"  
                }>
                    <Container className="vc-second-middle-container">
                        <Container className="rounded container-md vc-inner-container text-center position-relative">
                            {!messageErreur &&
                                < RendreComposant
                                    nomComposant={interaction.template_widget_model}
                                    interaction={interaction}
                                    afficherAccueil={afficherAccueil}
                                    afficherEtapeCollecteParticipation={afficherEtapeCollecteParticipation}
                                    afficherEtapeRemerciement={afficherEtapeRemerciement}
                                    afficherEtapeGRPD={afficherEtapeGRPD}
                                    afficherMessageErreur={afficherMessageErreur}
                                    afficherEtapeCollectInformationsPersonnelles={afficherEtapeCollectInformationsPersonnelles}
                                    afficherEtapeTemoinage={afficherEtapeTemoinage}
                                    changerEtapeCollecteParticipationVote={changerEtapeCollecteParticipationVote}
                                    changerAfficherEtapeCollecteParticipation={changerAfficherEtapeCollecteParticipation}
                                    changerEtapeRemerciement={changerEtapeRemerciement}
                                    changerAfficherEtapeGRPD={changerAfficherEtapeGRPD}
                                    changerAfficherEtapeCollectInformationsPersonnelles={changerAfficherEtapeCollectInformationsPersonnelles}
                                    changerAfficherMessageErreur={changerAfficherMessageErreur}
                                    changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                                    changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                                    setConsent={setConsent}
                                    consentGDPR={consentGDPR}
                                    consentImage={consentImage}
                                    passerEtapeRGPDEnabled={passerEtapeRGPDEnabled}
                                    setField={setField}
                                    saveDonneePersonnelle={saveDonneePersonnelle}
                                    audioBlob={audioBlob}
                                    setAudioBlob={setAudioBlob}
                                    audioURL={audioURL}
                                    videoURL={videoURL}
                                    setAudioURL={setAudioURL}
                                    setMessageErreur={setMessageErreur}
                                    setContinueEnabled={setContinueEnabled}
                                    continueEnabled={continueEnabled}
                                    sendingParticipationState={sendingParticipationState}
                                    participation={participation}
                                    userInformation={userInformation}
                                    donneesPersonnelleValid={donneesPersonnelleValid}
                                    videoBlob={videoBlob}
                                    setVideoBlob={setVideoBlob}
                                    setVideoURL={setVideoURL}
                                    retourAccueil={retourAccueil}
                                    resultatsVote={resultatsVote}
                                    handleRememberMeChange={handleRememberMeChange}
                                    rememberMe={rememberMe}
                                    passerPageTemoignage={passerPageTemoignage}
                                    canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                                    changerPage={changerPage}
                                    validateUserInformationsValid={validateUserInformationsValid}
                                    changerEtapeCollecteParticipationVideo={changerEtapeCollecteParticipationVideo}
                                    changerEtapeCollecteParticipationImage={changerEtapeCollecteParticipationImage}
                                    fetchResults={fetchResults}
                                    asAlreadyVoted={asAlreadyVoted}
                                    changerAfficherEtapeCollecteParticipationTexte={changerAfficherEtapeCollecteParticipationTexte}
                                    changerAfficherEtapeCollecteParticipationVoix={changerAfficherEtapeCollecteParticipationVoix}
                                    changerAfficherEtapeCollecteParticipationImage={changerAfficherEtapeCollecteParticipationImage}
                                    afficherEtapeCollecteParticipationTexte={afficherEtapeCollecteParticipationTexte}
                                    afficherEtapeCollecteParticipationVoix={afficherEtapeCollecteParticipationVoix}
                                    afficherEtapeCollecteParticipationImage={afficherEtapeCollecteParticipationImage}
                                />
                            }
                            <MessageErreurToast
                                afficherMessageErreur={afficherMessageErreur}
                                messageErreur={messageErreur}
                                setAfficherMessageErreur={setAfficherMessageErreur}
                            />
                        </Container>
                    </Container>
                </Container>
            </Container>
        </>
    );
}

export default HomePage;
